import { useState } from 'react';
import type { TaskConfigSettings } from '@pms/shared';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { TimePicker } from '@/components/ui/time-picker';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useConfigSettings } from './useConfigSettings';
import { ConfigTabShell } from './ConfigTabShell';

function Form({ initial, save, saving }: { initial: TaskConfigSettings; save: (p: Partial<TaskConfigSettings>) => void; saving: boolean }) {
  const [snapTime, setSnapTime] = useState(initial.report_snapshot_time);
  const [retention, setRetention] = useState(String(initial.report_retention_days));
  const dirty = snapTime !== initial.report_snapshot_time || Number(retention) !== initial.report_retention_days;
  return (
    <Card className="max-w-lg" variant="flat">
      <CardHeader><CardTitle>Report Rules</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-1.5">
          <Label>Daily snapshot time</Label>
          <TimePicker value={snapTime} onChange={setSnapTime} />
          <p className="text-xs text-muted-foreground">When the read-only daily report snapshot is captured.</p>
        </div>
        <div className="space-y-1.5">
          <Label>Snapshot retention (days)</Label>
          <Input type="number" min={1} max={3650} value={retention} onChange={(e) => setRetention(e.target.value)} />
        </div>
        <Button disabled={!dirty || saving} onClick={() => save({ report_snapshot_time: snapTime, report_retention_days: Number(retention) })}>
          {saving ? 'Saving…' : 'Save'}
        </Button>
        <p className="text-xs text-muted-foreground">Enforced by the report engine (Phase 2).</p>
      </CardContent>
    </Card>
  );
}

export function ReportRulesTab() {
  const { data, isLoading, isError, refetch, save, saving } = useConfigSettings();
  return (
    <ConfigTabShell isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && <Form initial={data} save={save} saving={saving} />}
    </ConfigTabShell>
  );
}
